import React from 'react'
import EmersonHeader from "../components/header/EmersonHeader";
// import BannerTen from "../components/banner/BannerTen";
import ServiceNine from "../components/service/ServiceNine";
import CallToActionSeven from "../components/calltoaction/CallToActionSeven";
import WhyChooseFour from "../components/whychooseus/WhyChooseFour";
import WhyTrustSembian from "../components/whychooseus/WhyTrustSembian";
import IndustriesWeServe from "../components/brand/IndustriesWeServe";
// import AboutSeven from "../components/about/AboutSeven";
// import TeamSix from "../components/team/TeamSix";
// import BrandOne from "../components/brand/BrandOne";
// import TestimonialThree from "../components/testimonials/TestimonialThree";
import BlogNine from "../components/blog/BlogNine";




import BannerEight from '../components/banner/BannerEight';
import FooterTwo from '../components/footer/FooterTwo';
import CookieBanner from '../components/CookieBanner';


function HomeThree() {
    return (
        <div className='home-blue home-ten'>

            <EmersonHeader />
           
            {/* <BannerTen /> */}
            <BannerEight />
            <ServiceNine />
            {/* <WhyTrustSembian /> */}
            <CallToActionSeven />
            <WhyChooseFour />
            <IndustriesWeServe />
            {/* <AboutSeven /> */}
            {/* <TeamSix /> */}
            {/* <BrandOne /> */}
            {/* <TestimonialThree /> */}
            <BlogNine />


            {/* <FooterSeven /> */}
            <CookieBanner />
            <FooterTwo />

        </div>
    )
}

export default HomeThree